import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteCommonProduct } from '../../../../actions/cargo';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';

class DeleteCommonProductButton extends Component {
  state = {
    showWarningModal: false,
  };

  showDeleteModal = () => this.setState({ showWarningModal: true });

  closeDeleteModal = () => this.setState({ showWarningModal: false });

  handleDelete = () => {
    const { commonProductId, dispatchDeleteCommonProduct } = this.props;
    dispatchDeleteCommonProduct({ commonProductId });
  };

  render() {
    const { showWarningModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showWarningModal}
        onClickConfirm={this.handleDelete}
        onClickCancel={this.closeDeleteModal}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.showDeleteModal}>
        Eliminar
      </Button>
    );
    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

DeleteCommonProductButton.propTypes = {
  commonProductId: PropTypes.string.isRequired,
  dispatchDeleteCommonProduct: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteCommonProduct: deleteCommonProduct,
};

export default connect(null, mapDispatchToProps)(DeleteCommonProductButton);
